// HAPPYCAP_AUTH_BLUE_TOP_FIX_V1
import { FEATURES } from "./config/features";
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { useEffect } from "react";

import LandingPage from "./pages/LandingPage";
import SignupTypeSelector from "./components/SignupTypeSelector";
import SignupAdult from "./components/SignupAdult";
import SignupMenor from "./components/SignupMenor";
import Login from "./components/Login";
import Signup from "./components/Signup";
import RequestReset from "./components/ResetPasswordRequest";
import ResetConfirm from "./components/ResetPasswordConfirm";
import InfoPage from "./pages/InfoPage";


import Activate from "./components/Activate";
import Dashboard from "./components/Dashboard";
import ProfileEdit from "./components/ProfileEdit";
import Logout from "./components/Logout";
import PrivateRoute from "./components/PrivateRoute";
import Navbar from "./components/Navbar";
import AdBanner from "./components/AdBanner";
import ChangePassword from "./components/ChangePassword";
import FeedPage from "./pages/FeedPage";
import NewPostPage from "./pages/NewPostPage";
import ProfilePage from "./pages/ProfilePage";
import ImageGallery from "./components/gallery/ImageGallery";
import SearchResultsPage from "./pages/SearchResultsPage";
import SearchHome from "./pages/buscador/SearchHome";
import SearchByPerfil from "./pages/buscador/SearchByPerfil";
import SearchByEnfermedad from "./pages/buscador/SearchByEnfermedad";
import SearchFriendsPage from "./pages/buscador/SearchFriendsPage";
import ProfilePublicPage from "./pages/ProfilePublicPage";
import Solicitudes from "./pages/Solicitudes";
import RecursosPage from "./pages/RecursosPage";
import MonetizacionPage from "./pages/MonetizacionPage";
import ChatPage from "./components/chat/ChatPage";

import { WebSocketProvider } from "./context/WebSocketContext";
import { AuthProvider } from "./auth/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import { SearchProvider } from "./context/SearchContext";
import SessionManager from "./components/SessionManager";

import PerfilTokenizadoPage from "./pages/PerfilTokenizadoPage";
import RecursosHome from "./pages/RecursosHome";
import AsociacionesPage from "./pages/AsociacionesPage";
import ProyectosPage from "./pages/ProyectosPage";
import CentrosPage from "./pages/CentrosPage";
import EarningsPage from "./pages/EarningsPage";
import AdBannerTest from "./components/AdBannerTest";
import MetodoPagoPage from "./pages/MetodoPagoPage";
import MetodoPagoFormPage from "./pages/MetodoPagoFormPage";
import HistorialRetirosPage from "./pages/HistorialRetirosPage";
import NubePalabras from "./pages/NubePalabras";

import PrivacyPage from "./pages/PolicyPage";
import CookiesPage from "./pages/CookiesPage";
import TermsPage from "./pages/TermsPage";
import LegalPage from "./pages/LegalPage";

import { useTranslation } from "react-i18next";

// 🧠 Extraemos la lógica en un wrapper con acceso a location
const AppWrapper = () => {
  const location = useLocation();
  const hideAd = location.pathname === "/chat"; // 👈 Ocultamos solo en /chat

  const { t } = useTranslation(); // ✅ i18next hook

  useEffect(() => {
    const main = document.getElementById("main-content");
    if (main) main.focus();
  }, [location]);

  return (
    <>
      <Navbar />
      <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
        <div
          id="main-content"
          tabIndex={-1}
          role="main"
          aria-label={t("a11y.main_content")} // ✅ aria-label traducido
          className={
            [
                "/",
                "/login",
                "/politica/terms",
                "/politica/privacy",
                "/politica/cookies",
                "/politica/legal",
                "/signup",
                "/signup/self",
                "/signup/menor",
                "/reset-password",
                "/reset-confirm"
              ].includes(location.pathname)
              ? location.pathname === "/"
              ? "min-h-screen bg-[#DCECF9] pt-6 px-0 pb-0"
              : ["/login", "/reset-password", "/signup", "/signup/menor", "/signup/self"].includes(location.pathname.replace(/\/$/, "")) ? ["/signup/self", "/signup/menor", "/reset-password"].includes(location.pathname.replace(/\/$/, "")) ? "min-h-screen bg-[#DCECF9] pt-6 sm:pt-8 px-0 pb-0" : "min-h-screen bg-[#DCECF9] pt-0 px-0 pb-0" : "min-h-screen bg-[#DCECF9] pt-16 px-0 pb-0"
              : `min-h-screen bg-[#DCECF9] pt-[52px] md:pt-20 px-2 ${hideAd ? "pb-4" : "pb-[140px]"}`
          }
        >

        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
            <Route path="/politica/privacy" element={<PrivacyPage />} />
            <Route path="/politica/cookies" element={<CookiesPage />} />
            <Route path="/politica/terms" element={<TermsPage />} />
            <Route path="/politica/legal" element={<LegalPage />} />

          <Route path="/signup" element={<SignupTypeSelector />} />
          <Route path="/signup/self" element={<SignupAdult />} />
          <Route path="/signup/menor" element={<SignupMenor />} />
          <Route path="/activate" element={<Activate />} />
          <Route path="/reset-password" element={<RequestReset />} />
          <Route path="/reset-confirm" element={<ResetConfirm />} />

          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/edit-profile" element={<PrivateRoute><ProfileEdit /></PrivateRoute>} />
          <Route path="/logout" element={<PrivateRoute><Logout /></PrivateRoute>} />
          <Route path="/change-password" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
          <Route path="/feed" element={<PrivateRoute><FeedPage /></PrivateRoute>} />
          <Route path="/new-post" element={<PrivateRoute><NewPostPage /></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
          <Route path="/gallery" element={<PrivateRoute><ImageGallery /></PrivateRoute>} />
          <Route path="/search" element={<PrivateRoute><SearchResultsPage /></PrivateRoute>} />
          <Route path="/solicitudes" element={<PrivateRoute><Solicitudes /></PrivateRoute>} />
          <Route path="/chat" element={<PrivateRoute><ChatPage /></PrivateRoute>} />
          <Route path="/ads-test" element={<AdBannerTest />} />

          <Route path="/buscar" element={<PrivateRoute><SearchHome /></PrivateRoute>} />
          <Route path="/buscar/perfil" element={<PrivateRoute><SearchByPerfil /></PrivateRoute>} />
          <Route path="/buscar/enfermedad" element={<PrivateRoute><SearchByEnfermedad /></PrivateRoute>} />
          <Route path="/buscar/amigos" element={<PrivateRoute><SearchFriendsPage /></PrivateRoute>} />
          <Route path="/perfil/:id" element={<PrivateRoute><ProfilePublicPage /></PrivateRoute>} />

          <Route path="/recursos" element={<PrivateRoute><RecursosHome /></PrivateRoute>} />
          <Route path="/recursos/asociaciones" element={<PrivateRoute><AsociacionesPage /></PrivateRoute>} />
          <Route path="/recursos/proyectos" element={<PrivateRoute><ProyectosPage /></PrivateRoute>} />
          <Route path="/recursos/centros" element={<PrivateRoute><CentrosPage /></PrivateRoute>} />
          <Route path="/recursos/nube-palabras" element={<PrivateRoute><NubePalabras /></PrivateRoute>} />
          <Route path="/monetizacion" element={FEATURES.monetization ? <PrivateRoute><MonetizacionPage /></PrivateRoute> : <Navigate to="/dashboard" replace />} />
          <Route path="/perfil-funcional" element={<PrivateRoute><PerfilTokenizadoPage /></PrivateRoute>} />
          <Route path="/monetizacion/ganancias" element={FEATURES.monetization ? <PrivateRoute><EarningsPage /></PrivateRoute> : <Navigate to="/dashboard" replace />} />
          <Route path="/perfil/metodo-pago" element={FEATURES.monetization ? <PrivateRoute><MetodoPagoPage /></PrivateRoute> : <Navigate to="/dashboard" replace />} />
          <Route path="/perfil/metodo-pago/:metodo" element={FEATURES.monetization ? <PrivateRoute><MetodoPagoFormPage /></PrivateRoute> : <Navigate to="/dashboard" replace />} />
          <Route path="/monetizacion/historial-retiros" element={FEATURES.monetization ? <PrivateRoute><HistorialRetirosPage /></PrivateRoute> : <Navigate to="/dashboard" replace />} />
          <Route path="/info" element={<PrivateRoute><InfoPage /></PrivateRoute>} />
        </Routes>
      </div>

      {!hideAd && <AdBanner />}
    </>
  );
};

function App() {
  const { i18n } = useTranslation();

    // 🎯 Establecer atributo lang dinámicamente
  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <Router>
      <WebSocketProvider>
        <AuthProvider>
          <SessionManager />
          <NotificationProvider>
            <SearchProvider>
              <AppWrapper />
            </SearchProvider>
          </NotificationProvider>
        </AuthProvider>
      </WebSocketProvider>
    </Router>
  );
}

export default App;
